/**
 *  @see https://stackoverflow.com/a/68463901
 *  @see https://www.unicode.org/reports/tr51/#EBNF_and_Regex
 */
const emojiRegex =
  /(?:\p{RI}\p{RI}|\p{Emoji}(?:\p{Emoji_Modifier}|\u{FE0F}\u{20E3}?|[\u{E0020}-\u{E007E}]+\u{E007F})?(?:\u{200D}\p{Emoji}(?:\p{Emoji_Modifier}|\u{FE0F}\u{20E3}?|[\u{E0020}-\u{E007E}]+\u{E007F})?)*)|[\u{1f900}-\u{1f9ff}\u{2600}-\u{26ff}\u{2700}-\u{27bf}]/gu

// Ensure that the string contains only one emoji
export const isEmoji = (icon: string): boolean => {
  const matches = icon.match(emojiRegex)
  if (!matches) return false
  return matches.length === 1 && !icon.replaceAll(matches[0], '')
}
